import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Checkbox, Modal } from "antd";
import moment from 'moment';


import { ModalForm } from './styles';
import CardHeader from "./NotificationsHeader/CardHeader/cardHeader";
import Content from "../../commons/components/content"
import ButtonAction from "../../commons/components/buttonAction";
import AccountTextArea from "../../commons/components/AccountTextArea/index";
import AccountInputValue from "../../commons/components/accountInputValue";
import AccountDatePicker from "../../commons/components/AccountDatePicker";
import AccountSelect from "../../commons/components/AccountSelect";
import DataSearch from "./dataSearch";
import AccountInputSearch from "../../commons/components/AccountInputSearch";
import AccountButtonAdd from "../../commons/components/AccountButtonAdd";
import AccountTable from "../../commons/components/AccountTable/";
import AccountModal from "../../commons/components/AccountModal/index";
import { RowFilters, ColFields, ColButtons } from "./NotificationsHeader/CardSearch/cardSearchStyles";

import NotificationService from "../../services/notifications";
import Message from "../../commons/utils/message";
import Permissions from "../../commons/utils/permissions";
import notificationModalModes from './NotificationModal/notificationModalModes';
import Http from "../../commons/utils/Http";
import Utils from "../../commons/utils/utils";

const Notifications = (props) => {
    const defaultPagination = { 
        current: 1, 
        pageSize: 10, 
        showSizeChanger: true, 
        pageSizeOptions: ['5', '10', '15', '20'],
    };

    const { screens } = useSelector(state => state.userLogin);

    const [tableData, setTableData] = useState([]);
    const [pagination, setPagination] = useState(defaultPagination);
    const [sorter, setSorter] = useState({ field: "name", order: "ascend" });

    const [permissions, setPermissions] = useState([]);
    const [search, setSearch] = useState("");
    const [loadingTable, setLoadingTable] = useState(false);

    const [users, setUsers] = useState([]);
    const [userList, setUserList] = useState([]);
    const [usersBeforeEdit, setUserBeforeEdit] = useState([]);

    const [selectedNotification, setSelectedNotification] = useState({});
    const [modeNotificationModal, setModeNotificationModal] = useState(null);

    const [showNotificationModal, setShowNotificationModal] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);

    const [nomeError, setNomeError] = useState(false);
    const [notificationError, setNotificationError] = useState(false);

    const actionTargetOptions = [
        { label: 'Mesma aba', value: 'self' },
        { label: 'Nova aba', value: 'blank' },
    ]
    const dateFormat = 'DD/MM/YYYY';
    const dateFormatDataBase = 'YYYY-MM-DD';

    const tableColumns = [
        {
            title: 'Id',
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: 'Nome',
            dataIndex: 'name',
            key: 'name',
            sorter: true,
            defaultSortOrder: 'ascend',
        },
        {
            title: 'Dt. Inicial',
            dataIndex: 'start_date',
            key: 'start_date',
        },
        {
            title: 'Dt. Final',
            dataIndex: 'end_date',
            key: 'end_date',
        },
        {
            title: 'Ação',
            key: 'action',
            width: '10%',
            render: (text, notification) => (
                <div style={{ display: 'flex' }}>

                    {(permissions.find(_function => _function.function_id === Permissions.EDITAR_NOTIFICACAO)) ?
                        <ButtonAction 
                            className="button-edit"
                            text="Editar Notificação" 
                            type="edit" 
                            callback={() => handleEditNotification(notification)}
                        />
                        : null
                    }

                    {(permissions.find(_function => _function.function_id === Permissions.EXCLUIR_NOTIFICACAO)) ?
                        <ButtonAction
                            className="button-red"
                            text="Excluir Notificação" 
                            type="delete" 
                            callback={() => handleDeleteNotification(notification)} 
                        />
                        : null
                    }
                </div>
            ),
        },
    ];

    useEffect(() => {
        const { functions } = screens.filter(screen => screen.url === "/notifications")[0];

        setPermissions(functions);
    }, [screens]);

    useEffect(() => {
        if(search === "") getNotifications();
    }, [search]);

    const getNotifications = async (
        paginationTable = defaultPagination, 
        sorterTable = { field: 'name', order: 'ascend'}
    ) => {
        setLoadingTable(true);
        const response = await (await NotificationService.getAll(paginationTable, sorterTable));
        
        if (response) {
            formatTable(response.data);
            setPagination({
                ...paginationTable,
                total: response.data.pagination,
                showTotal: (total) => `Notificações encontradas: ${total}`,
            });
            setLoadingTable(false);
        } else {
            setTableData([]);
            setLoadingTable(false);
            setPagination(defaultPagination);
        }

        setShowNotificationModal(false)
    }

    const formatTable = (data) => {
        let array = [];
        data.data.forEach((notification) => {
            notification.start_date = notification.start_date 
                ? moment(notification.start_date).format(dateFormat)
                : "Sem data";
            notification.end_date = notification.end_date 
                ? moment(notification.end_date).format(dateFormat)
                : "Sem data";

            array.push(notification);
        })
        setTableData(array);
    }

    const handleCancelDeleteNotification = () => {
        setSelectedNotification({});
        setShowDeleteModal(false);
    }

    const handleEditNotification = (notification) => {
        const { application_id, start_date, end_date } = notification;
        setLoadingTable(true);

        setSelectedNotification({ 
            ...notification, 
            application_id: Number(application_id),
            start_date: start_date !== "Sem data" ? start_date : null,
            end_date: end_date !== "Sem data" ? end_date : null,
        });
        if (notification.user_id) {
            setUserBeforeEdit(notification.user_id);
            setUsers(
                notification.user_id.map(user => `${user.name} - ${Utils.maskCpf(user.identification_number)}`))
        }

        setShowNotificationModal(true);
        setModeNotificationModal(notificationModalModes.EDIT);
        setLoadingTable(false);
    }

    const remove = ({ id }) => {
        setTableData(tableData.filter(notification => notification.id !== id));
    }

    const handleConfirmDeleteNotification = () => {
        setLoadingTable(true);
        remove(selectedNotification);
        setShowDeleteModal(false);
        setLoadingTable(false);
    }

    const handleCancelModalNotification = () => {
        setSelectedNotification({});
        setShowNotificationModal(false);
        setUsers([]);
        setNomeError(false);
        setNotificationError(false);
    }

    const handleDeleteNotification = (notification) => {
        setLoadingTable(true);
        setSelectedNotification(notification);
        setShowDeleteModal(true);
        setLoadingTable(false);
    }

    const searchNotification = async (
        searchInput = '', 
        paginationTable = defaultPagination, 
        sorterTable = { field: 'name', order: 'ascend'}
    ) => {
        setLoadingTable(true);
        let response = await NotificationService.search(searchInput, paginationTable, sorterTable);

        if (response) {
            formatTable(response.data);
            setPagination({
                ...paginationTable,
                total: response.data.pagination,
                showTotal: (total) => `Notificações encontradas: ${total}`,
            });
            setLoadingTable(false);
        } else {
            setTableData([]);
            setLoadingTable(false);
            setPagination(defaultPagination);
        }
    }

    const handleSearch = search => {
        setSearch(search);
        searchNotification(search);
    }

    const validateForm = () => {
        let valid = true;

        if (!selectedNotification.name) {
            setNomeError(true);
            Message.showError("Informe o nome");
            valid = false;
        }

        if (!selectedNotification.notification) {
            setNotificationError(true);
            Message.showError("Informe a notificação");
            valid = false;
        }

        return valid;
    }

    const returnConfirmAction = (paginationTable, sorterTable, searchTable) => {
        if (searchTable !== "") {
            searchNotification(searchTable, paginationTable, sorterTable);
        } else {
            getNotifications(paginationTable, sorterTable);
        }
        setShowNotificationModal(false);
        setUsers([]);
    }

    const update = async (data) => {
        const usersId = users.map(user => {
            for (let userBefore of usersBeforeEdit) {
                if(typeof(user) === 'string' && user.split(' -')[0] === userBefore.name) {
                    return `${userBefore.id}`;
                }
            }
            return `${user}`;
        }).join(',');

        const response = await NotificationService.update({ 
            ...data,
            start_date: data.start_date ? moment(data.start_date, dateFormat).format(dateFormatDataBase) : moment().format(dateFormatDataBase),
            end_date: data.end_date ? moment(data.end_date, dateFormat).format(dateFormatDataBase) : null,
            user_id: usersId ? usersId : null,
        });
        returnConfirmAction();
    }

    const insert = async (data) => {
        const response = await NotificationService.insert({ 
            ...data,
            start_date: data.start_date ? moment(data.start_date, dateFormat).format(dateFormatDataBase) : moment().format(dateFormatDataBase),
            end_date: data.end_date ? moment(data.end_date, dateFormat).format(dateFormatDataBase) : null,
            user_id: data.user_id ? data.user_id.join(',') : null,
        });
        returnConfirmAction();
    }

    const handleSaveModalNotification = () => {
        setLoadingTable(true);
        if (validateForm()) {
            if (selectedNotification.id) {
                update(selectedNotification);
            } else {
                insert(selectedNotification);
            }
        }
        setLoadingTable(false);
    }

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSaveModalNotification();
        }
    }

    const handleChangeInitialDateOfNotification = (date, dateString) => {
        setSelectedNotification({ ...selectedNotification, start_date: dateString })
    }

    const handleChangeFinalDateOfNotification = (date, dateString) => {
        setSelectedNotification({ ...selectedNotification, end_date: dateString });
    }

    const formatSelectData = (data) => {
        let array = [];
        if (data) {
            data.forEach((dataItem) => {
                let item = {}                
                item.label = `${dataItem.first_name} ${dataItem.last_name} - ${Utils.maskCpf(dataItem.identification_number)}`;
                item.value = dataItem.id;
                array.push(item)
            })
        }
        return array;
    }

    const searchUsers = async (search) => {
        const body = {
            "search": search,
            "order_fields": ["first_name", "last_name"],
            "order_type": "asc",
            "conditions": { "status": "ativo" }
        }
        Http.post(`/users/search-by`, body, Http.headers)
            .then(response => {
                const responseData = response.data
                if (!responseData.response.error) {
                    setUserList(formatSelectData(responseData.data.data));
                }
            }).catch(err => {
                setUserList([]);                
            })
    }

    const handleOnSearchUser = (e) => {
        searchUsers(e);
    }

    const handleOnChangeUser = (usersId) => {
        setUsers(usersId);
        setSelectedNotification({ ...selectedNotification, user_id: usersId })
    }

    const newNotificationModal = () => (
        <AccountModal
            style={{ paddingBottom: 0 }}
            title="Cadastro de Notificações" 
            visible={showNotificationModal} 
            onCancel={handleCancelModalNotification}
            footer={[
                <button key="cancel" onClick={() => setShowNotificationModal(null)} className="ant-btn">Cancelar</button>,
                <button key="confirm" onClick={handleSaveModalNotification} className="ant-btn ant-btn-primary">Salvar</button>
            ]}
        >
            <ModalForm>

                <ModalForm.Item>
                    <AccountInputValue
                        labelText="Nome"
                        value={selectedNotification.name ? selectedNotification.name : ''}
                        hasError={nomeError}
                        onChange={(e) => { 
                            setSelectedNotification({ ...selectedNotification, name: e.target.value });
                            setNomeError(false) 
                        }}
                        error={'Informe o nome'}
                        onKeyPress={(e) => handleKeyPress(e)}
                        disabled={modeNotificationModal === notificationModalModes.VIEW}
                    />
                </ModalForm.Item>

                <ModalForm.Item>
                    <AccountTextArea
                        labelText="Notificação"
                        value={selectedNotification.notification ? selectedNotification.notification : ''}
                        hasError={notificationError}
                        error={'Informe a notificação'}
                        rows={3}
                        onChange={(e) => { setSelectedNotification({ ...selectedNotification, notification: e.target.value }); setNotificationError(false) }}
                        onKeyPress={(e) => handleKeyPress(e)}
                        disabled={modeNotificationModal === notificationModalModes.VIEW}
                    />
                </ModalForm.Item>

                <Row gutter={8}>

                    <Col span={12}>
                        <ModalForm.Item>
                            <AccountDatePicker
                                labelText={"Dt. Inicial"}
                                value={selectedNotification.start_date ? moment(selectedNotification.start_date, dateFormat) : null}
                                format={dateFormat}
                                placeholder={""}
                                onChange={handleChangeInitialDateOfNotification}
                                disabled={modeNotificationModal === notificationModalModes.VIEW}
                            />
                        </ModalForm.Item>
                    </Col>

                    <Col span={12}>
                        <ModalForm.Item>
                            <AccountDatePicker
                                labelText={"Dt. Final"}
                                value={selectedNotification.end_date ? moment(selectedNotification.end_date, dateFormat) : null}
                                format={dateFormat}
                                placeholder={""}
                                onChange={handleChangeFinalDateOfNotification} 
                                disabled={modeNotificationModal === notificationModalModes.VIEW}
                            />
                        </ModalForm.Item>
                    </Col>

                </Row>

                <Row gutter={8}>

                    <Col span={12}>
                        <ModalForm.Item>
                            <AccountInputValue
                                labelText="Texto do botão"
                                value={selectedNotification.button_text ? selectedNotification.button_text : ''}
                                onChange={(e) => { setSelectedNotification({ ...selectedNotification, button_text: e.target.value }) }}
                                onKeyPress={(e) => handleKeyPress(e)}
                                disabled={modeNotificationModal === notificationModalModes.VIEW}
                            />  
                        </ModalForm.Item>
                    </Col>

                    <Col span={12}>
                        <ModalForm.Item>
                            <AccountInputValue
                                labelText="Tipo da ação"
                                value={selectedNotification.action_type ? selectedNotification.action_type : ''}
                                onChange={(e) => { setSelectedNotification({ ...selectedNotification, action_type: e.target.value }) }}
                                onKeyPress={(e) => handleKeyPress(e)}
                                disabled={modeNotificationModal === notificationModalModes.VIEW}
                            />  
                        </ModalForm.Item>
                    </Col>
                </Row>

                <ModalForm.Item>
                    <AccountInputValue
                        labelText="Url de ação"
                        value={selectedNotification.action_url ? selectedNotification.action_url : ''}
                        onChange={(e) => { setSelectedNotification({ ...selectedNotification, action_url: e.target.value }) }}
                        onKeyPress={(e) => handleKeyPress(e)}
                        disabled={modeNotificationModal === notificationModalModes.VIEW}
                    />
                </ModalForm.Item>

                <Row gutter={8}>

                    <Col span={12}>
                        <ModalForm.Item>
                            <AccountInputValue
                                labelText="Delay Time"
                                value={selectedNotification.delay_time ? selectedNotification.delay_time : ''}
                                onChange={(e) => { setSelectedNotification({ ...selectedNotification, delay_time: e.target.value })}}
                                onKeyPress={(e) => handleKeyPress(e)}
                                disabled={modeNotificationModal === notificationModalModes.VIEW}
                            />
                        </ModalForm.Item>
                    </ Col>
                    
                    <Col span={12}>
                        <ModalForm.Item>
                            <DataSearch 
                                disabled={modeNotificationModal === notificationModalModes.VIEW}
                                value={selectedNotification.application_id ? selectedNotification.application_id : null}
                                onChange={(e) => setSelectedNotification({ ...selectedNotification, application_id: e })}
                            />
                        </ModalForm.Item>
                    </Col>
                </ Row>

                <ModalForm.Item>
                    <AccountSelect
                        value={selectedNotification.action_target ? selectedNotification.action_target : ''}
                        labelText="Alvo da ação"
                        list={actionTargetOptions}
                        onChange={(e) => setSelectedNotification({ ...selectedNotification, action_target: e })}
                        disabled={modeNotificationModal === notificationModalModes.VIEW}
                        showSearch={false}
                    />
                </ModalForm.Item>

                <ModalForm.Item>
                    <AccountSelect
                        mode="multiple"
                        value={users}
                        labelText="Selecione os usuários por Nome, e-mail ou CPF dos usuários"
                        list={userList}
                        onSearch={handleOnSearchUser}
                        onChange={handleOnChangeUser} 
                    />
                </ModalForm.Item>

                <Row gutter={5} style={{ height: '20px' }}>
                    <Col span={12}>
                        <ModalForm.Item>
                            <Checkbox
                                id="cbPopover"
                                checked={selectedNotification.popover}
                                onChange={() => { 
                                    setSelectedNotification({ 
                                        ...selectedNotification, 
                                        popover: !selectedNotification.popover 
                                    });
                                }}
                                disabled={modeNotificationModal === notificationModalModes.VIEW}
                            />
                            <label 
                                htmlFor="cbPopover" 
                                className="p-checkbox-label" 
                                style={{ marginLeft: '5px' }}
                            >
                                Popover
                            </label>
                        </ModalForm.Item>
                    </Col>

                    <Col span={12}>
                        <ModalForm.Item>
                            <Checkbox
                                id="cbPartnerOnly"
                                checked={selectedNotification.partner_only}
                                onChange={() => { 
                                    setSelectedNotification({ 
                                        ...selectedNotification, 
                                        partner_only: !selectedNotification.partner_only 
                                    }); 
                                }}      
                                disabled={modeNotificationModal === notificationModalModes.VIEW}                      
                            />
                            <label 
                                htmlFor="cbPartnerOnly" 
                                className="p-checkbox-label" 
                                style={{ marginLeft: '5px' }}
                            >
                                Partner Only
                            </label>
                        </ModalForm.Item>
                    </Col>
    
                </Row>
            </ModalForm>
        </AccountModal>
    );

    const deleteNotificationModal = () => (
        <Modal 
            visible={showDeleteModal} 
            title="Excluir notificação"
            onCancel={handleCancelDeleteNotification} 
            cancelText="Cancelar" 
            onOk={handleConfirmDeleteNotification} 
            okText="Excluir"
            okType="danger"
        >
            <p>Tem certeza que deseja excluir a notificação <strong>{selectedNotification.name}</strong> ?</p>
            <small><strong><p>Após concluída, essa ação não poderá ser desfeita.</p></strong></small>
        </Modal>
    );

    const renderAddNotificationButton = () => {
        if (permissions.find(_function => _function.function_id === Permissions.CADASTRAR_NOTIFICACAO)) {
            function handleOpenModal() {
                setShowNotificationModal(true)
                setSelectedNotification({ popover: false, partner_only: false });
                setModeNotificationModal(notificationModalModes.INSERT);
            }

            return (
                <AccountButtonAdd
                    label="Criar nova notificação"
                    onClick={handleOpenModal}
                />
            )
        }
    };

    const handleOnChangeTable = (paginationTable, filtersTable, sorterTable, currentPageData) => {
        setSorter(sorterTable);
        setPagination(paginationTable);
        returnConfirmAction(paginationTable, sorterTable, search);
    }

    const renderTable = () => (
        <>
            <Col span={24}>
                <AccountTable 
                    columns={tableColumns}
                    dataSource={tableData}
                    pagination={pagination}
                    loading={loadingTable}
                    onChange={handleOnChangeTable}
                />
            </Col>
        </>
    );

    const renderHeader = () => (
        <RowFilters style={{ width: '100%' }}>
            <ColFields flex="auto">
                <AccountInputSearch
                    placeholder="Pesquisar notificação"
                    style={{ width: 300, marginRight: 6 }}
                    onSearch={e => handleSearch(e)}
                />
            </ColFields>
            <ColButtons>
                {renderAddNotificationButton()}
            </ColButtons>
        </RowFilters>
    );

    return (
        <Content minHeight={360}>
            <CardHeader />
            {newNotificationModal()}
            {deleteNotificationModal()}
            <Row type="flex" align="middle">
                {renderHeader()}
            </Row>
            <Row>
                {renderTable()}
            </Row>
        </Content>
    )
}

export default Notifications;
